import { AppIdentifier } from "../../types";
import { appIdentifierToActionPrefixMap } from "../../types";
import {
  ACTION_SET_JWT,
  ACTION_SET_MODAL_STATE,
  ACTION_APP_LOADED
} from "./constants";

export interface ICryptoWithdrawalsState {
  jwt: string;
  isAppLoaded: boolean;
  isAppActive: boolean;
}

export interface ICryptoWithdrawalsAction {
  type: string;
  jwt?: string;
  isAppActive?: boolean;
  isAppLoaded?: boolean;
}

const INITIAL_STATE: ICryptoWithdrawalsState = {
  jwt: "",
  isAppActive: false,
  isAppLoaded: false
}

const applySetIsAppActive = (state: ICryptoWithdrawalsState, action: ICryptoWithdrawalsAction) : ICryptoWithdrawalsState => {
  return {
      ...state,
      isAppActive: !!action.isAppActive,
  }
}

const applySetSendJWTToApp = (state: ICryptoWithdrawalsState, action: ICryptoWithdrawalsAction) : ICryptoWithdrawalsState => {
  return {
      ...state,
      isAppLoaded: !!action.isAppLoaded,
  }
}

const applySetJWT = (state: ICryptoWithdrawalsState, action: ICryptoWithdrawalsAction) : ICryptoWithdrawalsState => {
  return {
      ...state,
      jwt: action.jwt as string,
  }
}

const reducerMap: { [actionType: string]: (state: ICryptoWithdrawalsState, action: ICryptoWithdrawalsAction) => ICryptoWithdrawalsState } = {
  // Crypto Withdrawals reducer
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_WITHDRAWALS)}${ACTION_SET_JWT}`]: applySetJWT,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_WITHDRAWALS)}${ACTION_SET_MODAL_STATE}`]: applySetIsAppActive,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_WITHDRAWALS)}${ACTION_APP_LOADED}`]: applySetSendJWTToApp,
};

const cryptoWithdrawalsReducer = (state = INITIAL_STATE, action: ICryptoWithdrawalsAction) => {
  if (!!action.type && !!reducerMap[action.type]) {
      return reducerMap[action.type](state, action);
  } else {
      return state;
  }
}

export default cryptoWithdrawalsReducer;
